export const NAMESPACE = 'ShareBets';
